import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Toaster } from "sonner";
import "react-toastify/dist/ReactToastify.css";
import DashboardLayout from "./layout/DashboardLayout";
import Dashboard from "./pages/Dashboard";
import ClientList from "./pages/ClientList";
import CreateNew from "./pages/CreateNew";
import UploadDocuments from "pages/UploadDocuments";
import Login from "pages/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import "./App.scss";



function App() {
  return (
    <div className="app">
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />


          <Route path="/" element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }>
            {/* Note: only these 3 page can be protectd dashbord page , create-new & all-list page and other page no protected */}
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="all-list" element={<ClientList />} />
            <Route path="create-new" element={<CreateNew />} />
          </Route>

          <Route path="upload-documents" element={
            <UploadDocuments />
          } />

          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
